/**
 * @fileoverview Spinner component using lucide Loader icon.
 * @module components/ui/spinner
 */

import { LoaderIcon } from 'lucide-react'
import type { ComponentProps, ReactElement } from 'react'
import { cn } from '@/shared/utils/cn'

/**
 * Spinner props extending SVG props for customization.
 */
export type SpinnerProps = ComponentProps<'svg'>

/**
 * A small, customizable loading spinner.
 *
 * @component
 * @example
 * ```tsx
 * <Spinner className="size-6 text-muted-foreground" />
 * ```
 */
export function Spinner({ className, ...props }: SpinnerProps): ReactElement {
  return (
    <LoaderIcon
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  )
}
